import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.app.title',
    defaultMessage: 'Assistance',
  },
  description: {
    id: 'app.containers.app.description',
    defaultMessage: 'DRSA-WEB-APP',
  },
  action_confirm: {
    id: 'app.containers.app.action.confirm',
    defaultMessage: 'Confirm',
  },
  action_cancel: {
    id: 'app.containers.app.action.cancel',
    defaultMessage: 'Cancel',
  },
  action_ok: {
    id: 'app.containers.app.action.ok',
    defaultMessage: 'Ok',
  },
  action_retry: {
    id: 'app.containers.app.action.retry',
    defaultMessage: 'Retry',
  },
  action_yes: {
    id: 'app.containers.app.action.yes',
    defaultMessage: 'Yes',
  },
  action_no: {
    id: 'app.containers.app.action.no',
    defaultMessage: 'No',
  },
  required_label: {
    id: 'app.containers.app.required.label',
    defaultMessage: 'Required',
  },
  impressum: {
    id: 'app.containers.app.appBar.impressum',
    defaultMessage: 'Impressum',
  },
});
